import React from "react";
import DemoPopup from "./DemoPopup";
import popupBannerAsset from "../../assets/images/product-demo-asset_2.png";
import { hasUTMConsent } from "../../utilities/helpers";

const InteractiveDemoPopup = ({
  isOpen,
  closeModal,
  demoUrl = "/explore-product/",
}) => {
  const handleTryDemo = () => {
    // Build detailed UTM parameters only if user has consented
    let url = "/explore-product/";

    if (hasUTMConsent()) {
      const utmParams = new URLSearchParams({
        utm_source: "popup",
        utm_medium: "modal",
        utm_campaign: "product_demo",
        utm_content:
          typeof window !== "undefined" ? window.location.pathname : "",
      });
      url = `/explore-product/?${utmParams.toString()}`;
    }

    window.open(url, "_blank");
    closeModal();
  };

  return (
    <DemoPopup isOpen={isOpen} closeModal={closeModal}>
      <div className="flex flex-col lg:flex-row">
        {/* Left side - Interactive demo interface */}
        <div className="lg:w-1/2 w-full min-w-0 rounded-l-2xl overflow-hidden relative flex-shrink-0">
          <img
            src={popupBannerAsset}
            loading="eager"
            fetchPriority="high"
            alt="Encord annotation interface demo"
            className="w-full h-full object-cover absolute inset-0"
          />
        </div>

        {/* Right side - Content */}
        <div className="flex-1 flex flex-col justify-center p-6 lg:p-8 bg-white rounded-r-2xl">
          <div className="max-w-md">
            <div className="text-purple-600 text-sm font-medium uppercase tracking-wider mb-4">
              INTERACTIVE PRODUCT DEMO
            </div>

            <h2 className="text-3.25xl sm:text-[60px] font-manrope leading-[40px] sm:leading-[68px] font-medium tracking-[-2.2px] sm:tracking-[-3px] mb-6 hero_turner_strong_color_style">
              See Encord
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-purple-800">
                in Action
              </span>
            </h2>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed font-inter font-normal">
              Explore how you can manage, curate and annotate your data at
              scale.
            </p>

            <button
              onClick={handleTryDemo}
              className="w-full bg-purple-1500 text-white hover:bg-purple-400 font-semibold px-8 py-4 rounded-full text-lg transition-all duration-200 shadow-lg popup-demo-button"
            >
              Start the tour
            </button>
          </div>
        </div>
      </div>
    </DemoPopup>
  );
};

export default InteractiveDemoPopup;
